import {
  IBankTransaction,
  IPurchaseTransaction,
  TransactionTypeEnum
} from '@/services/types/TransactionData';
import { TTransactionHistory } from '../types/TransactionHistory';
import { transactionTypes } from '../data/transactionTypes';

export const getTransactionType = (transaction: TTransactionHistory) => {
  switch (transaction.type) {
    case TransactionTypeEnum.Bank: {
      const bankLabels = transactionTypes.filter(
        (el) => el.transactionType === TransactionTypeEnum.Bank
      );
      const inputData = transaction.data as IBankTransaction;
      return bankLabels.find((el) => el.type == inputData.type.toLowerCase())?.displayName;
    }
    case TransactionTypeEnum.Transfer:
    case TransactionTypeEnum.Admin: {
      return transactionTypes.find((el) => el.transactionType === transaction.type)?.displayName;
    }
    case TransactionTypeEnum.TopUp: {
      return 'Top up';
    }
    case TransactionTypeEnum.EmergePay: {
      return 'Emerge Pay';
    }
    case TransactionTypeEnum.Purchase: {
      const data = transaction.data as IPurchaseTransaction;
      switch (data.source) {
        case 'pos':
          return 'In-Store';
        case 'atm':
          return 'ATM';
        case 'online':
          return 'Online';
        case 'other':
          return 'Other';
      }
    }
  }
};
